import { useState, useCallback, Fragment } from "react";
import { Button, Modal, message } from "antd";
import { useNavigate } from "react-router-dom";
import { announcement as announcementService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

const columns = ["公告", "成刊", "学习交流"];

function PublishButton({ announcementId, form }) {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const auth = useAuthContext();
  const navigate = useNavigate();
  const clickHandler = useCallback(() => {
    setVisible(true);
  }, [setVisible]);
  const okHandler = useCallback(async () => {
    const results = await form.validate();
    if (results) {
      setVisible(false);
      return;
    }
    const values = form.values;
    const { attachments = [], sendee = [] } = values;
    if (announcementId) {
      setLoading(true);
      announcementService
        .updateAnnouncement(
          announcementId,
          {
            ...values,
            status: 1,
            records: sendee,
            attachments: attachments.map((a) => a.id || a.response.id),
          },
          auth.token
        )
        .then((res) => {
          if (res.status_code === 400) {
            const { status_code, ...rest } = res;
            const messages = Object.values(rest).flat();
            message.error(messages.join(", "));
          } else {
            setVisible(false);
            message.success("操作成功");
            navigate("/workshop/announce/draft");
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(true);
      announcementService
        .createAnnouncement(
          {
            ...values,
            status: 1,
            records: sendee,
            attachments: attachments.map((a) => a.response.id),
          },
          auth.token
        )
        .then((res) => {
          if (res.status_code === 400) {
            const { status_code, ...rest } = res;
            const messages = Object.values(rest).flat();
            message.error(messages.join(", "));
          } else {
            setVisible(false);
            message.success("操作成功");
            navigate("/workshop/announce/draft");
          }
        })
        .finally(() => {
          setVisible(false);
          setLoading(false);
        });
    }
  }, [announcementId, auth, form, navigate]);
  const cancelHandler = useCallback(() => {
    setVisible(false);
  }, [setVisible]);
  const { column = 0, title, sendee = [] } = form.values;
  return (
    <Fragment>
      <Button onClick={clickHandler}>发布</Button>
      <Modal
        title="确认提交"
        visible={visible}
        onOk={okHandler}
        okButtonProps={{ loading }}
        onCancel={cancelHandler}
        okText="确认"
        cancelText="取消"
      >
        <p>栏目：{columns[column]}</p>
        <p>标题：{title}</p>
        <p>接收单位： {sendee.map((s) => s.name).join(", ")}</p>
      </Modal>
    </Fragment>
  );
}

export default PublishButton;
